import { createFileRoute } from "@tanstack/react-router";
import { ProjektoekonomiPage, projektoekonomiHead } from "@/pages/ProjektoekonomiPage";

export const Route = createFileRoute("/de/projektoekonomie")({
  head: () => projektoekonomiHead("de"),
  component: () => <ProjektoekonomiPage locale="de" />,
});
